export async function handleCancel({ userId, onClose, toast, setLoadingCancel }) {
    setLoadingCancel(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_PAYMENTAPI_URL}cancel-subscription`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: parseInt(userId, 10) }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Cancellation failed');
      localStorage.setItem('subscriptionCancelPending', 'true');
      onClose();
    } catch (err) {
      console.error('Error:', err);
      toast({
        title: 'Cancel Subscription',
        description: err.message,
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top',
      });
    } finally {
      setLoadingCancel(false);
    }
  }
  
  export async function handlePortal({ userId, setLoadingPortal }) {
    setLoadingPortal(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_PAYMENTAPI_URL}create-portal-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: parseInt(userId, 10) })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Failed to create portal session');
      localStorage.setItem('subscriptionPortalPending', 'true');
      window.location.href = data.url;
    } catch (err) {
      alert('Error: ' + err.message);
      console.error(err);
    } finally {
      setLoadingPortal(false);
    }
  }
  
  export async function handlePayment({priceId,userId,email,toast,setLoadingPlan}) {
    if (!priceId) {
      alert('This plan does not require payment.');
      return;
    }
  
    const userIdInt = parseInt(userId, 10);
    if (isNaN(userIdInt)) {
      alert('Payment Error: Invalid user ID');
      console.error('Invalid user ID:', userId);
      return;
    }
    if (!email || typeof email !== 'string' || !email.includes('@')) {
      alert('Payment Error: Invalid email address');
      console.error('Invalid email:', email);
      return;
    }
  
    setLoadingPlan(priceId);
  
    try {
      console.log('Sending request with:', { user_id: userIdInt, email, price_id: priceId });
      const response = await fetch(`${process.env.REACT_APP_PAYMENTAPI_URL}create-checkout-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userIdInt, email, price_id: priceId }),
      });
  
      const data = await response.json();
      console.log('Backend response:', data);
  
      if (!response.ok) {
        let errorMessage = 'Failed to create session';
        if (data.detail) {
          errorMessage = typeof data.detail === 'string' ? data.detail : JSON.stringify(data.detail);
        } else {
          errorMessage = JSON.stringify(data) || errorMessage;
        }
        throw new Error(errorMessage);
      }
  
      localStorage.setItem('subscriptionUpdatePending', 'true');
      window.location.href = data.url;
    } catch (err) {
      let errorMessage = err.message;
      try {
        const parsedError = JSON.parse(err.message);
        errorMessage = parsedError.detail || JSON.stringify(parsedError) || err.message;
      } catch (_) {}
      toast({
        title: 'New Subscription',
        description: errorMessage,
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top',
      });
      console.error('Error details:', err, 'Response data:', err.message);
    } finally {
      setLoadingPlan(null);
    }
  }
  